import React, { useState } from "react";
import { Delete as DeleteIcon } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const DeleteConfirmation = ({ onConfirm, data }) => {
  const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);

  const onClickDeleteButton = () => {
    setIsOpenDeletePopup(true);
  };

  const handlClosePopup = () => {
    setIsOpenDeletePopup(false);
  };

  const handleConfirmDelete = () => {
    handlClosePopup();
    onConfirm(data);
  };
  return (
    <div>
      <Dialog open={isOpenDeletePopup} onClose={handlClosePopup} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{"Are you sure? You want to delete?"}</DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={handlClosePopup} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant="contained" color="secondary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton aria-label="expand row" size="small" onClick={onClickDeleteButton}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
};
export default DeleteConfirmation;
